import { p as proxyCustomElement, H, c as createEvent, h, d as Host } from './p-BJEvNVLM.js';
import { b as bem } from './p-g1JgJ7wn.js';
import { r as resolveAppearance } from './p-CkrRd9Ud.js';
import { u as unscopeTagName } from './p-BrBYYH1P.js';
import { A as ACTIVATE_KEYS } from './p-C8iutPqo.js';
import { d as defineCustomElement$2 } from './p-BMLmP8GU.js';

const cosmosActionMenuItemCss = ":host{display:block;max-width:100%;position:relative;width:100%}:host(:focus){outline:none}:host(:focus)::before{content:\"\";border-radius:calc(2.66px * 1.5);bottom:calc((4px + -4px) * -1);box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + -4px) * -1);position:absolute;right:calc((4px + -4px) * -1);top:calc((4px + -4px) * -1)}.cosmos-action-menu-item{align-items:center;background:var(--cosmos-action-menu-item-background-color);border-radius:var(--cosmos-action-menu-item-border-radius, 4px);box-sizing:border-box;cursor:default;display:flex;gap:6px;justify-content:space-between;margin:0;max-width:100%;padding:8px;position:relative;-webkit-user-select:none;user-select:none;width:100%;--cosmos-text-color:var(--cosmos-action-menu-item-color);--cosmos-text-font-family:var(--cosmos-action-menu-item-font-family);--cosmos-text-font-size:var(--cosmos-action-menu-item-font-size);--cosmos-text-font-style:var(--cosmos-action-menu-item-font-style);--cosmos-text-font-weight:var(--cosmos-action-menu-item-font-weight);--cosmos-text-letter-spacing:var(--cosmos-action-menu-item-letter-spacing);--cosmos-text-line-height:var(--cosmos-action-menu-item-line-height);--cosmos-text-text-transform:var(--cosmos-action-menu-item-text-transform)}.cosmos-action-menu-item--anchor{color:inherit;position:relative;text-decoration:none}.cosmos-action-menu-item__side{align-items:center;display:flex;flex:4;gap:var(--cosmos-action-menu-item-gap, 6px);max-width:fit-content;min-width:0}.cosmos-action-menu-item__side--meta{flex:1}.cosmos-action-menu-item__meta{--cosmos-text-font-family:var(--cosmos-action-menu-item-meta-font-family);--cosmos-text-font-size:var(--cosmos-action-menu-item-meta-font-size);--cosmos-text-font-style:var(--cosmos-action-menu-item-meta-font-style);--cosmos-text-font-weight:var(--cosmos-action-menu-item-meta-font-weight)}.cosmos-action-menu-item:hover{background:var(--cosmos-action-menu-item-background-color-hover, rgba(0, 15, 30, 0.05))}.cosmos-action-menu-item--active{background:var(--cosmos-action-menu-item-background-color-active, rgba(0, 15, 30, 0.05))}.cosmos-action-menu-item--active:hover{background:var(--cosmos-action-menu-item-background-color-active-hover, rgba(0, 15, 30, 0.1))}.cosmos-action-menu-item--appearance-light{--cosmos-icon-color:#FFFFFF}.cosmos-action-menu-item--appearance-light:hover{background:var(--cosmos-action-menu-item-background-color-active-hover, rgba(255, 255, 255, 0.05))}.cosmos-action-menu-item--appearance-light.cosmos-action-menu-item--active{background:var(--cosmos-action-menu-item-background-color-active, rgba(255, 255, 255, 0.05))}.cosmos-action-menu-item--appearance-light.cosmos-action-menu-item--active:hover{background:var(--cosmos-action-menu-item-background-color-active-hover, rgba(255, 255, 255, 0.1))}.cosmos-action-menu-item ::slotted([slot=prefix]){flex:0 0 auto;--cosmos-icon-size:18px;--cosmos-flag-width:18px;--cosmos-avatar-size:18px}";

const CosmosActionMenuItem$1 = /*@__PURE__*/ proxyCustomElement(class CosmosActionMenuItem extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.actionClick = createEvent(this, "actionclick", 7);
        /**
         * Represents an item currently in use or influencing the interface.
         */
        this.active = false;
        /**
         * The meta information text of the action item.
         */
        this.meta = '';
        this.generateClassNames = bem('cosmos-action-menu-item');
    }
    handleAppearanceChange(appearance) {
        this.computedAppearance = appearance;
    }
    handleClick() {
        this.actionClick.emit({ itemId: this.itemId });
    }
    handleKeyDown(event) {
        if (ACTIVATE_KEYS.includes(event.key)) {
            this.actionClick.emit({ itemId: this.itemId });
        }
    }
    composeTitle() {
        var _a;
        const label = (_a = this.element.textContent) === null || _a === void 0 ? void 0 : _a.trim();
        if (this.meta) {
            return `${label} • ${this.meta}`;
        }
        return label;
    }
    getUnscopedComponentName() {
        // Make sure we have an unscoped tag name available as a data attribute so we can
        // use it to target slotted elements in a scoped environment
        return unscopeTagName(this.element.tagName.toLowerCase());
    }
    componentDidLoad() {
        resolveAppearance({
            instance: this,
            modeToAppearanceMap: { dark: 'light', light: 'dark' },
            callback: this.handleAppearanceChange.bind(this),
        });
    }
    render() {
        var _a;
        const Tag = this.href ? 'a' : 'div';
        return (h(Host, { key: '22caab2acbe5a2220d3946bbbe910773860a75a7', role: "menuitem", id: this.itemId, "aria-label": (_a = this.element.textContent) === null || _a === void 0 ? void 0 : _a.trim(), "data-component-name": this.getUnscopedComponentName() }, h(Tag, { key: 'ea7195debca067d0963605b968bd5587ea7a59d5', class: this.generateClassNames({
                anchor: !!this.href,
                appearance: this.computedAppearance,
                active: this.active,
            }), href: this.href, rel: this.rel, target: this.target, part: "base", tabindex: -1 }, h("div", { key: 'c01be7f531707a6a868822766bbe0f57d3441c9a', class: this.generateClassNames('side'), title: this.composeTitle() }, h("slot", { key: '8dcd09ab3165434606a0a793ea534571e6142449', "aria-hidden": "true", name: "prefix" }), h("cosmos-text", { key: '4e8864b833279fdb6ee3f83a95c856f4981d1ff8', appearance: this.appearance, exportparts: "base: label", class: this.generateClassNames('label'), size: "small", clamp: 1 }, h("span", { key: '11781629aa91b7cf3280290ee27a955fa6829914' }, h("slot", { key: '35bf24ba9856d0b66a3a96f6fd40dd4bd5058289' })))), h("div", { key: '51a5abb856bb3f9bf69a4b87bc7f1cffd3f33bd9', class: this.generateClassNames('side', {
                meta: !!this.meta,
            }) }, this.meta && (h("cosmos-text", { key: '26d27e20d714066806231db5f8393bf484ae9d77', appearance: this.appearance, class: this.generateClassNames('meta'), clamp: 1, size: "x-small", kind: "subtle" }, h("span", { key: 'f45abf625af48326bb9de30f555c45c7accdbdc5' }, this.meta)))))));
    }
    get element() { return this; }
    static get watchers() { return {
        "appearance": ["handleAppearanceChange"]
    }; }
    static get style() { return cosmosActionMenuItemCss; }
}, [1, "cosmos-action-menu-item", {
        "active": [516],
        "appearance": [513],
        "href": [513],
        "itemId": [513, "item-id"],
        "meta": [513],
        "rel": [513],
        "target": [513],
        "computedAppearance": [32]
    }, [[0, "click", "handleClick"], [0, "keydown", "handleKeyDown"]], {
        "appearance": ["handleAppearanceChange"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-action-menu-item", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-action-menu-item":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosActionMenuItem$1);
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosActionMenuItem = CosmosActionMenuItem$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosActionMenuItem, defineCustomElement };
